import { FC, useCallback, useEffect, useState } from 'react';
import { Cookie, CookieProps } from './components/Cookie';
import { LocalStorageKeys } from 'helpers/localStorage';

type AdditionalModalProps = Pick<CookieProps, 'bottom'>;

export const AdditionalModal: FC<AdditionalModalProps> = (props) => {
  const [isOpenCookieModal, setIsOpenCookieModal] = useState(false);

  useEffect(() => {
    setIsOpenCookieModal(localStorage.getItem(LocalStorageKeys.Cookie) == null);
  }, []);

  const handleAcceptCookie = useCallback(() => {
    localStorage.setItem(LocalStorageKeys.Cookie, 'true');
    setIsOpenCookieModal(false);
  }, [setIsOpenCookieModal]);

  return (
    <>
      {isOpenCookieModal && <Cookie onClose={handleAcceptCookie} {...props} />}
    </>
  );
};
